import { render, staticRenderFns } from "./4mDetail.vue?vue&type=template&id=6fe4e38a"
import script from "./4mDetail.vue?vue&type=script&lang=js"
export * from "./4mDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe4e38a')) {
      api.createRecord('6fe4e38a', component.options)
    } else {
      api.reload('6fe4e38a', component.options)
    }
    module.hot.accept("./4mDetail.vue?vue&type=template&id=6fe4e38a", function () {
      api.rerender('6fe4e38a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/4mDetail.vue"
export default component.exports